export enum SidebarFeatureEnum {
  Tournament = 'tournament',
}
